import { HttpClient } from '@angular/common/http';
import { Injector } from '@angular/core';
import { AuthenticationHttpHandlerService } from '../services/api';

export function createAuthenticatedHttpClient(injector: Injector): HttpClient {
  return new HttpClient(injector.get(AuthenticationHttpHandlerService));
}
